import { defineComponent as _defineComponent } from 'vue'
import WidgetForm from '@/components/WidgetForm/WidgetForm.vue';
import { ref, watch } from 'vue';
import { useInject } from '@/components/SideBar/composables';
import { WidgetContentKey } from '../types';
import TileError from './TileError.vue';
import { FlowRunAssetsKey, FlowRunErrorAssetsKey } from './types';
import EndRun from '@/views/FlowRun/EndRun.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'FlowRunContent',
  setup(__props) {

const { showWidget, widgetToRender, handleWidgetNode } = useInject(WidgetContentKey);
const { canSeeDetails, isFailed, mainErrorMessage, dismiss, showErrorDetails } = useInject(FlowRunErrorAssetsKey);
const { restart, endRunData } = useInject(FlowRunAssetsKey);
const widgetLayout = ref<InstanceType<typeof WidgetForm> | null>(null);
watch(widgetToRender, (newVal) => {
	if (newVal) {
		widgetLayout.value?.setWidget(newVal);
	}
});
const logoSrc = ref<string>('');
const isLogoActive = ref<boolean>(false);
const isShowingEndRun = ref<boolean>(false);

return { __sfc: true,showWidget, widgetToRender, handleWidgetNode, canSeeDetails, isFailed, mainErrorMessage, dismiss, showErrorDetails, restart, endRunData, widgetLayout, logoSrc, isLogoActive, isShowingEndRun, WidgetForm, TileError, EndRun }
}

})